import { render, staticRenderFns } from "./SimpleVehicleViewAddonsTable.vue?vue&type=template&id=5d127c39&"
import script from "./SimpleVehicleViewAddonsTable.vue?vue&type=script&lang=js&"
export * from "./SimpleVehicleViewAddonsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports